// Module
var code = "<p>[# summary]</p> <h3 id=\"资产-symbol\">资产 {symbol}</h3> <p>{description}<br>发行人 {issuer}</p> <p>美元 (标识: $; 符号: USD) 是美利坚合众国的官方货币。</p> ";
// Exports
export default code;